import { render, staticRenderFns } from "./ParamEdit.vue?vue&type=template&id=b058e1c0&scoped=true"
import script from "./ParamEdit.vue?vue&type=script&lang=js"
export * from "./ParamEdit.vue?vue&type=script&lang=js"
import style0 from "./ParamEdit.vue?vue&type=style&index=0&id=b058e1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b058e1c0",
  null
  
)

export default component.exports